import { Check, X } from "lucide-react";
import { LoginViewState } from "../types";
import { useConfirmEmail } from "../hooks/useConfirmEmail";
import { StatusIconCircle } from "@/components/common/StatusIconCircle";
import { SubmitButton } from "../components/SubmitButton";
import { ViewHeading } from "../components/ViewHeading";

type Props = {
  confirmation: string;
  onViewChange: (view: LoginViewState) => void;
};

export const ConfirmEmailView = ({ confirmation, onViewChange }: Props) => {
  const { checking, confirmed } = useConfirmEmail(confirmation);

  if (checking) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <div className="w-10 h-10 border-4 border-brand-pink/20 border-t-brand-pink rounded-full animate-spin mb-4" />
        <p className="text-[clamp(0.875rem,1vw,1.1rem)] text-[#6B7280]">Confirming your email…</p>
      </div>
    );
  }

  return (
    <>
      <StatusIconCircle variant={confirmed ? "success" : "error"} icon={confirmed ? Check : X} />

      <ViewHeading
        title="Klipboard CRM Email Confirmation"
        subtitle={
          confirmed
            ? "Your email address has been confirmed. Please continue to login to Klipboard CRM or close this page."
            : "Unable to confirm your email address. Please try again or request a new confirmation email link."
        }
      />

      <SubmitButton type="button" onClick={() => onViewChange("login")}>
        Continue to Klipboard CRM
      </SubmitButton>
    </>
  );
};
